import { render } from "./VsudSnackbar.vue?vue&type=template&id=22a08e81"
import script from "./VsudSnackbar.vue?vue&type=script&lang=js"
export * from "./VsudSnackbar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/thuyninh/Sites/yamaha_lms_fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__